import { createRoutes } from './helpers';
import views from './views';

const RoutesOpen = createRoutes(views);

export default RoutesOpen;



// WEBPACK FOOTER //
// ./src/routes/RoutesOpen.js